import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
  table: {
    minWidth: 650,
  },
  paperLeft: {
    marginBottom: theme.spacing(3),
    marginRight: theme.spacing(3),
    padding: theme.spacing(3),
  },
  inputLabel: {
    fontSize: 15,
    transform: 'scale(1)',
    color: '#212121',
  },
  variantPaper: {
    padding: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
  frontChip: {
    color: '#fff',
    marginRight: 10,
  },
  endChip: {
    color: '#fff',
    marginLeft: 10,
  },
  testTypeSelect: {
    width: 140,
  },
  segmentColumn: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: 120,
  },
  testTargetType: {
    // display: 'inline-block',
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  testTargetValue: {
    // display: 'inline-block',
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
}));

export default useStyles;
